export default function CounterAcronymBadge({
  acronym,
  value,
  className,
}: {
  acronym: string;
  value?: number;
  className?: string;
}) {
  return (
    <div
      className={`rounded-md bg-white px-2 py-1 font-semibold text-gray-800 border border-gray-600 text-xs overflow-hidden ${className}`}
    >
      {acronym}
      {value && <span>:</span>}
      {value && <span className="text-gray-500">{` ${value}`}</span>}
    </div>
  );
}
